<template>
    <div id="root">
      <div id="app" class="logged-in" >
    <div id="app-menu" :class="isModalKharid == true  ? 'custom':''" >
      <div id="app-menu-content-wrapper">
        <div v-if="isLoading == false" id="app-menu-content">
            <div style="margin-top: 20px" class="text-button" >

              <textarea  autoresize autocomplete="off" type="text" v-on:keydown.enter="handleEnter" autofocus="" id="textarea-input" v-model="chatbox"  style="padding:10px;text-align: start;unicode-bidi: plaintext;overflow-y: auto;resize: none;width:100%;height:100%;min-height:110px;line-height:25px;display:block;font-size:17px;font-family: IRANSansWeb;color:white;outline: none;" placeholder="📝 توضیحی از عکسی که میخوای بسازی اینجا بنویس، هر چقدر توضیحت کامل تر و با جزئیات بیشتری باشه، نتیجه بهتری میگیری."  />
              <div class="quick-nav-item"  style="background-color:#6153cc;display:flex;border-radius:15px;" >
              <span class="overflow2" @click="randomPrompt()" style="display:block;padding:7px;font-size:17px;font-family: IRANSansWeb;color:white;text-decoration:underline;text-decoration">نمیدونی چی بنویسی؟
            </span>
            <div style="display:flex">
            <i @click="gotoHistory()" style="padding:10px;margin:auto;color:white" class="fa-solid fa-clock-rotate-left"></i>
            <i @click="chatbox = ''" style="padding:15px;margin:auto;color:white" class="fa-solid fa-trash"></i>
          </div>
          </div>
        </div>
            <div style="display:flex;margin-top:5px;padding:5px">
            <span style="line-height:20px;font-size:10px;font-weight:bold;font-family: IRANSansWeb;color:white"><i style="padding:3px;color:white" class="fa-solid fa-star"></i>
متن توصیفی وارد شده به زبان انگلیسی، نتیجه و تصویر بهتری را ایجاد خواهد کرد.</span>
          </div>
          <div v-if="selectedStyle == null" style="display:flex;padding:5px">
            <span style="line-height:20px;font-size:10px;font-weight:bold;font-family: IRANSansWeb;color:white"><i style="padding:3px;color:white" class="fa-solid fa-star"></i>
می توانید یکی از سبک های پایین را انتخاب کنید و سبک عکس خود را تغییر دهید.</span>
          </div>
          <div v-if="selectedStyle != null" class="text-button2" style="padding:10px;margin-top:5px;border-radius:10px;">
            <div style="display:flex;justify-content:space-between">
              <div class="menu-section-title">
              <span style="font-size:17px;font-weight:bold;font-family: IRANSansWeb;color:rgb(231, 231, 231);">
                <i style="margin-top:10px;padding:3px;color:white" class="fa-solid fa-check"></i>انتخاب شده: {{ this.selectedStyle.name}}</span>
            </div>
            <div class="menu-section-title" @click="deleteSelected()" style="display:flex;padding:13px;">
              <i style="color:rgb(255, 0, 0);font-size:20px;" class="fa-solid fa-x"></i>
              <span style="margin-right:8px;margin-top:-2px;font-size:15px;font-weight:bold;font-family: IRANSansWeb;color:rgb(255, 0, 0);">
                حذف
                </span>
              </div>
            
          </div>
          <div class="tool-card-background background-image" style="width:75vw;height:75vw; border-radius:20px;margin:auto;margin-bottom:20px" :style="{ backgroundImage: 'url(' + this.selectedStyle.image + ')' }"></div>
        </div>
          <div id="tools-section" class="menu-section" style="margin-bottom:80px">
           <div style="display:flex;justify-content:space-between"><div class="menu-section-title">
                <i class="fa-solid fa-envelope" aria-hidden="true"></i>
              <span class="menu-section-title-text" >تعدادی از سبک ها</span>
            </div>
            <div class="menu-section-title">
              <span @click="gotoStyle()" class="menu-section-title-text text-button2" style="padding:10px;border-radius:10px;font-weight:200;font-size:1.0em">مشاهده  همه</span>
            </div>
          </div>
            <div class="scrollable-component menu-section-content" style="height: 100%;">
              <div  v-for="style in styles" :key="style.id" @click="selectStyle(style.styleId,style.name,style.image3)" class="tool-card quick-nav-item">
                <div class="tool-card-background background-image" :style="{ backgroundImage: 'url('+style.image3+')' }"></div>
              </div>
              
            </div>
          </div>
        </div>
        <div v-else style=" height: 100vh;">
            <div style="position: relative;top: 40%;-webkit-transform: translateY(-50%);-ms-transform: translateY(-50%);transform: translateY(-50%);">
          <div style="vertical-align: middle;text-align: center;">
          <span style="font-size:20px;font-weight:bold;font-family: IRANSansWeb;color:white;">
            در حال خلق ایده شما به واقعیت...
            </span>
          </div>
            
          <lottie :options="defaultOptions" style="margin-top:-40px;" v-on:animCreated="handleAnimation"/>
          <div style="margin-top:-40px;vertical-align: middle;text-align: center;">
          <span style="font-size:17px;font-weight:bold;font-family: IRANSansWeb;color:white;">
            لطفا منتظر بمانید
            </span>
          </div>
        </div>
        </div>
      </div>
      
      </div>

      <div  v-if="isModalKharid == false && isLoading == false" @click="generateImage()" class="circle-div" style="z-index:10;box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);cursor:pointer">
        
        <div style="position: absolute;left: 50%;top:50%;transform: translate(-50%, -50%)">
        <span style="line-height:20px;font-size:22px;font-weight:bold;font-family: IRANSansWeb;color:white">خلق تصویر   </span>
        <i style="color:white;font-size:22px" class="fa-regular fa-images"></i>
      </div>
      </div>
      <div v-if="isModalKharid" class="login-box scrolling" style="overflow-y: auto;">
        <div class="basket scrollfix"><div class="purchaseSuccess mx-2 my-4 px-3 py-2 rounded-2 bg-cff6e9 position-relative">
            <i @click="isModalKharid = false" class="fa-solid fa-x" style="margin-top:5px;font-size: 15px;color:white;margin-top:-10px"></i>
            <h5 class="mb-4 fw-bold pt-2" style="font-size:17px;font-weight: bold;margin-top:-15px;">روبو شکمش خالیه! ☹️</h5>
            <p style="white-space: pre-line;
      padding: 0;
      color: #fff;font-size: 15px;
      text-align: center;margin-bottom:-15px" class="font-12 pb-4 text" >ای وای، کوکیات🍪 تموم شده ولی ما هواتو داریم.
</p>
<hr>
<p style="white-space: pre-line;
      padding: 0;
      color: #fff;font-size: 14px;line-height: 25px;
      text-align: right;margin-bottom:-5px" class="font-12 pb-4 text">با خریدن بیشتر کوکی‌🍪، رویاهایتان را به واقعیت تبدیل کنید. از خلق کردن بی‌وقفه لذت ببرید و به امکانات ویژه دسترسی داشته باشید.</p>
                <button @click="gotoPackages()" type="submit" class="text-white btn w-100" style="font-weight:bold;background-color: #E23E57;"><i class="fa-solid fa-shopping-basket" style="margin-left:5px;color:white"></i>همین حالا خرید کنید!</button>
                <hr>
                <p style="white-space: pre-line;
      padding: 0;
      color: #fff;font-size: 14px;line-height: 25px;
      text-align: right;margin-bottom:-5px" class="font-12 pb-4 text">روبو را به اشتراک بگذارید! یک دوست را به روبو معرفی کنید و برای هر معرفی موفقیت‌آمیز، ۵۰ کوکی🍪 هم شما و دوستتان دریافت می کنید.</p>
                <button @click="isModalKharid = false;showReferral()" style="font-weight:bold;margin-bottom:5px;" type="submit" class="text-white btn btn-info w-100"><i class="fa-solid fa-user-friends" style="margin-left:5px;color:white"></i>دعوت دوستان</button>
                <div v-if="isApplication" style="margin-bottom:5px;">   
                <hr>
                <p style="white-space: pre-line;
      padding: 0;
      color: #fff;font-size: 14px;line-height: 25px;
      text-align: right;margin-bottom:-5px" class="font-12 pb-4 text">همچتین میتونید با دیدن تبلیغی کوتاه، 3 کوکی🍪 رایگان دریافت کنید.</p>
                <button @click="showAd()" type="submit" class="text-white btn btn-primary w-100" ><i class="fa-solid fa-play" style="margin-left:5px;color:white"></i>تماشای ویدیو</button>
                </div>
            </div><!----><!----></div>
    </div>
    </div>
    
    <br/>
    <br/>
    <br/>
</div>
</template>
<script>
/* eslint-disable */
import router from '@/router';
import axios from 'axios';
import Lottie from 'vue-lottie';
import * as animationData from '@/assets/img/test.json';
import { notify } from "@kyvg/vue3-notification";
var Timer;
  export default {
    name: 'App',
    components: {
      'lottie': Lottie
    },
    data() {
      return {
        defaultOptions: {animationData: animationData,autoplay:true},
        animationSpeed: 1,
        anim:null,
        isModalKharid:false,
        showNameDialog:false,
        name:"",
        isLoading: false,
        credit:0,
        mobile:null,
        chosenName:"",
        selectedStyle: null,
        chatbox:"",
        texts:[],
        inputText:"",
        searchbox:"",
        styles:[],
        prompts:[
        "پرتره یک کودک در حال بازی در پارک، با استفاده از نور طبیعی و بیان صورت‌های رند.",
"پرتره یک سرباز بازنشسته در لباس نظامی، با نور قوی و جهت‌گیری قوی.",
"پرتره یک هنرمند خیابانی در حال اجرا با پس‌زمینه‌ای شلوغ از شهر به عنوان پس‌زمینه مات.",
"پرتره ایستایلیزه یک کارآفرین در برابر خطوط شهر، با نور نمایشی و طراحی آینده‌نگرانه.",
"پرتره یک ماهیگیر پیر در دریا، با استفاده از نور طبیعی برای برجسته کردن بافت‌های پیرهنه.",
"پرتره یک رقاص حرفه‌ای که احساسات خود را از طریق حرکت‌ها بیان می‌کند، با نور نمایشی.",
"پرتره شادی از کسی که در باران می‌خندد، با استفاده از سرعت شات بالا برای یخ‌زدگی قطرات باران.",
"پرتره یک پیاده‌رو تنها در قله یک کوه در ساعت طلایی.",
"پرتره فعال یک ورزشکار در حین بازی، با استفاده از سرعت شات سریع و عکس‌های نزدیک.",
"پرتره افرازی از یک فرد در محیط طبیعی و خیالی با نور نرم.",
"نقاشی واقع‌گرایانه از یک صحنه پاییزی با یک بلوار درخت‌پوش با برگ‌های رنگارنگ در زمین.",
"عکس سیاه و سفید از یک شخص لباس 1920، در مقابل یک ساختمان قدیمی از آجر.",
"نقاشی واقع‌گرایانه از لحظه‌ی آرامی بین یک کودک و حیوان خانگی‌اش، با تأکید بر عبارت و مزاج.",
"عکس خیابان شلوغ شهر در ساعت غروب، از زاویه‌ای پایین گرفته شده، با ساختمان‌های بلند و چراغ‌های نئون روشن.",
"نقاشی واقع‌گرایانه از صحنه آرام وحشت‌زده با یک دریاچه آرام، احاطه شده توسط درختان پاپلار در غروب آفتاب.",
"عکس با رزولوشن بالا از اشیاء روزمره در مقابل یک پس‌زمینه کم‌جلوه، با تأکید بر جزئیات و بافت.",
"نقاشی واقع‌گرایانه از یک مناره تنها به صورت سیلوئت در مقابل رنگ‌های جذاب غروب آفتاب.",
"نقاشی واقع‌گرایانه از صحنه زیر سقف جنگل با نور خورشید که از میان برگ‌ها می‌تابد و جزئیات غنی را در زیر کره جنگل نشان می‌دهد.",
"پرتره عکاسی در ساعت طلایی، با تأکید بر نور گرم و جو آرام.",
"صحنه انیمه از یک قهرمان در حال مبارزه با موجودات سایه در یک جنگل ماهتابی، با برجسته کردن چشمان روشن موجودات و نقشه مصممانه قهرمان.",
"تصویر انیمه از یک توکیو آینده‌نگر، پر از ابر‌نوران نئون، وسایل هواپیمایی شناور، و عناصر سنتی مانند یک شینتو جلیقه.",
"صحنه انیمه از دانش‌آموزان دبیرستانی که با دوستانشان سرگرمی دارند.",
"تصویر انیمه از یک نقاشی با اژدهای با شخصیت در یک مکان متروکه کوهستانی، با تأکید بر اندازه اژدها و تعامل مهربانانه.",
"نمایش انیمه از یک مدرسه جادویی پر از دانش‌آموزانی که نوازش‌ها و موجودات اسرارآمیز را تجربه می‌کنند، با لوحه رنگی و جزئیات مفصل.",
"نقاشی انیمه از یک نوع جنگجوی مکانیزه با زره‌های سنگین و اسلحه آینده‌نگر، با تمرکز بر خطوط پویا و تضاد رنگ قوی.",
"صحنه انیمه از یک شخصیت در حال مواجهه با روحانیان در یک جنگل جادویی و سحرآمیز، با پس‌زمینه مهتابی، گیاهان روشن و موجودات خیالی.",
"نمایش انیمه از یک سامورای سایبرنتیک در یک محیط پساپوکالیپس، با تمرکز بر پیچیدگی‌های زره و اسلحه.",
"صحنه انیمه از یک دریانورد در کشتی خیالی که در اقیانوس‌های عالی حرکت می‌کند و با سایرن‌ها روبرو می‌شود، با تمرکز بر رنگ‌های جذاب دریا و آسمان، و شخصیت‌های بیان‌کننده.",
"صحنه انیمه از یک گروه جنگجو در حال ایستادگی آخرین خود در برابر ارتش هیولاها، با برجسته کردن تضاد نور و تاریکی و صورت‌های مصمم جنگجوها.",
"تصویری از یک مرد نشسته در یک صفحه پارک.",
"تصویری از یک مرد نشسته در یک صفحه پارک زیر درخت، برگ‌های زرد پاییزی دور او می‌افتند.",
"نقاشی امپرسیونیستی از یک پیرمرد نشسته در یک صفحه پارک، در حال تغذیه کبوتران در میان بارانی از برگ‌های زرد پاییزی.",
"یک ربات خندان در غروب آفتاب.",
"ساخت تصویر سه‌بعدی از یک گلاب با برگ‌های آبی منحصر به فرد و یک طراحی مفهومی.",
"نقاشی امپرسیونیستی از یک کوه با نسبت جلوه بصری گسترده.",
"ساخت تصویر چشم‌نواز از یک بیگانه از دیدگاه گرفته شده.",
"تصویر جذاب یک گرگ با استفاده از عناصر طراحی حداقل و رنگ‌های روشن.",
"ایجاد یک تصویر با کیفیت بالا از یک موشک با استفاده از سبک کیوبیست.",
"مدل سه‌بعدی یک زن پیر در تابستان، با استفاده از سبک رنسانس و نسبت ظریف.",
"مدل سه‌بعدی یک ستاره درخشان با رنگ‌های پاستل و ظاهر خیالی.",
"مدل 3D یک ستاره درخشان با رنگ‌های پاستل و ظاهری شگفت‌آور.",
"تصویری از یک مگس که با موتورسیکلت سوار است، در یک جهان موج امواج بخار با دید دیدگاه گسترده.",
"یک پرسش برای یک عکس با سه دوست که هماهنگی در جاده را مثل سبک هنر پاپ بازی می‌کنند.",
"یک صحنه غیرمعمول که شامل یک گروه از سگ‌های گلدن رتریور در یک ریو به سبک عصر رنسانس در یک ریو است.",
"توصیف یک قلعه به سبک گوتیک با دیدی هوایی، با تأکید بر طبیعت مرموز آن.",
"تصویر نمایشی از یک میز اداری نوین در 3D با اثر پس‌زمینه متمرکز به نام بوکه.",
"توصیف یک نقاشی از ایستگاه قطار از جنبش هنر کوبیست با بافت‌ها و رنگ‌های واقع‌گرایانه.",
"تصویری از یک مرد که در رختخواب در حالت پرقدرتی دراز کشیده است و به نظر می‌آید که در حال رویاپردازی در سیاه و سفید است.",
"تولید یک توصیف از یک نقاشی روغنی به سبک امپرسیونیستی از ساحل فوق‌العاده زیبا در غروب آفتاب.",
"یک دید هوایی از یک عکس به سبک ادوارد هاپر از خط شهر.",
"تصویر 3D با وضوح بالا از یک گربه اریستوکراتیک که روی پنجره نشسته است.",
"یک خیابان شهری با نقاشی به سبک گرافیتی با سطوح بافت دار.",
"نقاشی سیاه و سفید شامل بافت‌ها واقع‌گرایانه با وضوح بالا.",
"یک نقاشی سورئالیستی از مورچه‌ها که یک پیکنیک خانوادگی در مرکز پارک سنترال حمله می‌کنند.",
"نقاشی با آبرنگ شامل رنگ‌های زنده و عناصر سورئالی یک کافه.",
"یک رنگین‌کمان در آسمان بیابان شهر روستایی ترک‌شده با سبک کلاسیک.",
"تصویر 3D از یک فضاپیما که به سمت فضا حرکت می‌کند با آستتیک سایبرپانک و مقیاس گسترده.",
"یک ایستگاه فضایی مدرن با نورپردازی سینمایی، تنوع جواهری و فتو‌رئالیسم افرازی.",
"یک قورباغه با تاج که در یک دمنوشه نشسته است به سبک انیمه ژاپنی.",
"محل درخارستان از دهه ۱۹۶۰ خارج از یک کافه با رنگ‌های تکراری و جوی وینتیج.",
"یک ربات قدیمی دستگاه بازی ویدئویی پیشرفته را با رنگ‌های نئون و رزولوشن متوسط بازی می‌کند.",
"یک قلعه به سبک گوتیک آمریکایی در تاریکی، با خفاش‌ها پرپر می‌شود.",
"یک GIF انیمیشنی به سبک کارتونی که یک ربات به موسیقی دهه ۸۰ حرکات می‌زند.",
"یک نمایش عکس از سبک آنسل ادامز از یک خانواده در ساحل.",
"یک نقاشی انتزاعی از یک آفتابگردان در میان یک بیابان با رنگ‌های زنده و وضوح پایین.",
"تصویری از یک بار در کنار ساحل که دارای رنگ‌های بنفش و صورتی به سبک هنر پاپ در شب است.",
"تصویری از یک باغ با گلهای در حال شکوفا شدن در شب تحت نور ماه با دوربین به سمت زمین نگاه می‌کند.",
"تصویری از یک قلعه روی تپه سنگی با احساس فیلمی.",
"یک نقاشی از یک زن ایستاده بر صخره به سمت دریا با دیدی هنری و خاص.",
"تصویر یک شهر در شب با نورهای رنگارنگ و دیدی مدرن.",
"تصویری سه‌بعدی از یک فضاپیما که از فضا عبور می‌کند با سبک وان گوگ و پیش‌زمینه و پس‌زمینه واضح.",
"دو گربه بر روی یک مبل نشسته‌اند، اسپاگتی می‌خورند و تلویزیون تماشا می‌کنند.",
"هیولاهای چسبیده به سبک کیوبیسم با رنگ‌های روشن و وضوح پایین.",
"نمای هوایی از یک نفر که تنها از جنگل عبور می‌کند به سبک رمانتیسم.",
"با تنظیمات تاریک و رزولوشن پشت‌نور، این نقاشی روغن تعریفی از یک طوفان به سبک شهر نشینی را نشان می‌دهد.",
"نمایش نسخه‌ای از یک ایستگاه قطار آینده‌نگار با نورپردازی حجمی به سبک آرت نووو.",
"تصویر امپرسیونیستی از یک رودخانه که از میانه یک چمنزار می‌گذرد با یک خط خیلی ضخیم.",
"عکسی از یک تصویر سیاه و سفید از یک نفر که از نشستن به غروب خورشید خیره شده است.",
"خط شهری یک شهر با رنگ‌های روشن و وضوح بالا نقاشی شده است.",
"یک طرح از دو ربات که با یکدیگر صحبت می‌کنند، با دیدی سورئال و نسبت تصویر به ارتفاع.",
"یک کلاژ ابستره در تنظیم نئون و رزولوشن 4K از یک جهان پسا‌آخرالزمانی.",
"با عناصر انتزاعی و سبک روکوکو، نقاشی یک باغ را با وضوح بالا نشان می‌دهد.",
"تصویری از یک پیرمرد که در بحر ماهی گیری کرده است، با نمایش نور خورشید خشنی از خشکی پوستش.",
"بافت‌های واقع‌گرایانه، یک نقاشی با آبرنگ از یک گله از پرندگان در غروب آفتاب.",
"تصویری از یک کودک که در یک پارک خوشحال است، با نور طبیعی و نمایش احساسات واقعی.",
"تصویری از یک سرباز در لباسش، با نورپردازی روشن از یک جهت.",
"تصویری از یک نفر که در خیابان اجرا می‌کند با پس‌زمینه شهر پرهیز.",
"یک تصویر جذاب از یک تاجر در مقابل خط شهر با نورپردازی آینده‌نگار.",
"تصویری از یک پیرمرد که در اقیانوس ماهی می‌گیرد، با نمایش نور خورشید خشنی از خشکی پوستش.",
"تصویری از یک نفر که با حرکات خود احساسات را نشان می‌دهد، با نورپردازی فانتزی.",
"تصویر خوشحالی از یک نفر که در حال بخشیدن به باران است، با تنظیمات سریع دوربین برای گرفتن حرکت قطرات باران.",
"تصویری از یک نفر که تنها بر روی قله کوه در غروب خورشید قدم می‌زند.",
"عکس‌های نمای نزدیکی از یک ورزشکار در حال بازی که از دوربینی که به سرعت عکس می‌گیرد.",
"تصویری از یک خیابان با درختان در رنگ‌های پاییز و برگ‌ها بر روی زمین.",
        ],
        isApplication: navigator.userAgent.match(/ir.roboo.pwa/i)?true:false,
        isMobile: navigator.userAgent.match(/Android/i)
             || navigator.userAgent.match(/webOS/i)
             || navigator.userAgent.match(/iPhone/i)
             || navigator.userAgent.match(/iPad/i)
             || navigator.userAgent.match(/iPod/i)
             || navigator.userAgent.match(/BlackBerry/i)
             || navigator.userAgent.match(/Windows Phone/i)?true:false,
        conversations:[
           
        ]
      };
    },
    methods:{
      gotoHistory()
      {
        router.push('/CreatedImage');
      },
      gotoPackages(){
            router.push('/packages');
        },
      showReferral()
        {
            this.$emit("showReferral");
        },
      showAd()
        {
            notify({
      title: "روبو",
      text: "در حال اماده سازی ویدیو. لطفا منتظر بمانید!",
      type: "info"
    });
    this.isModalKharid=false;
    this.userInfo.credit = this.userInfo.credit +3;
    this.$emit("setCredit");

    try {
        Android.ShowAdAdivery('8a4d6b52-0e81-4470-8755-c1e6e08806fa',"3");
        //Android.ShowAd('64b58b3c4bf57453cab34119',"3");
    }
    catch {
        try{
          Android.ShowAd('64b58b3c4bf57453cab34119',"3");
        }
        catch{
          Android.ShowAd('64b58b3c4bf57453cab34119');
        }
    }
        },
      randomPrompt()
      {
        const prmpt = this.prompts[Math.floor(Math.random() * this.prompts.length)];
        this.chatbox = prmpt;
      },
      selectStyle(id,name,image)
    {
      localStorage.setItem("selectedStyleName",name);
      localStorage.setItem("selectedStyleId",id);
      localStorage.setItem("selectedStyleImage",image);
      this.selectedStyle = {id,name,image};
    },
    deleteSelected()
    {
      localStorage.removeItem("selectedStyleName");
      localStorage.removeItem("selectedStyleId");
      localStorage.removeItem("selectedStyleImage");
      this.selectedStyle = null;
    },
      handleEnter(event) {
            if(this.isMobile)
            return;
            if ((event.shiftKey &&event.key === 'Enter')) {
        // Allow the default behavior of creating a new line on Android devices
        return;
      }
     
          event.preventDefault();
          this.generateImage();
        },
        gotoStyle(id)
        {
          router.push("/styles");
        },
      generateImage()
        {
          if(this.chatbox != "")
          {
            this.isLoading = true;
            let isFarsi = false;
            let char = new RegExp("[\u0600-\u06FF]");
                if (char.test(this.chatbox) === true) {
                    isFarsi = true;
                }
            var styleId = '';
            if(this.selectedStyle != null)
            {
              styleId = this.selectedStyle.id
            }
            
            let json = {
                token : localStorage.getItem("token"),
                prompt: this.chatbox,
                farsi: isFarsi,
                styleId:styleId
            }
    
             axios.post("https://api3.roboo.ir/api/image/generateimage",json).then(response => {
                
             if(response.data.status == 0)
             {
                  console.log(response.data.message);
                  this.userInfo.credit = this.userInfo.credit-3;
                  this.$emit("setCredit");
                  router.push({ path: "/imagepreview", query: { id: response.data.message,refrence:"imagegeneration" } });
             } 
             else if(response.data.status == 2)
             {
              this.isLoading = false;

                this.istyping = false;
                this.isModalKharid = true;
                return;
             }
             else
             {
              this.isLoading = false;
                notify({
      title: "خطا",
      text: response.data.message,
      type: "error"
    });
    return;
             }
            }).catch(r=>{
              this.isLoading = false;
                notify({
      title: "خطا",
      text: "هنگام ارسال درخواست مشکلی پیش آمد \nوضعیت اینترنت خود را بررسی کنید",
      type: "error"
    });
    return;
            });
            
          }
          else
          {
            notify({
      title: "خطا",
      text: "متن ساخت تصویر خالی است.\nلطفا متن خود را در قسمت بالا بنویسید.",
      type: "error"
    });
          }
      },
      
      returnCharacterName(character)
      {
        if(character == "chat")
        return "روبو"
        else if(character == "moshaver")
        return "مشاور"
        else if(character == "mechanic")
        return "مکانیک"
        else if(character == "barnamenevis")
        return "برنامه نویس"
        else if(character == "translator")
        return "مترجم"
        else if(character == "teacher")
        return "معلم"

        else
        return "روبو"
      },
      getRandomStyles()
      {
        axios.get("https://api3.roboo.ir/api/image/GetRandomStyles")
        .then(response=>{
          console.log(response.data)
              this.styles = response.data;
          });
        
      },
      tryToSearch()
      {
        clearTimeout(Timer);
        Timer = setTimeout(this.search, 1000);
      },
    },
    mounted(){
      var token = localStorage.getItem("token");
      if(this.isApplication)
      {
              Android.setToken(token);
        }
      if(localStorage.getItem("savedPrompt") != null)
      {
        this.chatbox = localStorage.getItem("savedPrompt");
        localStorage.removeItem("savedPrompt");
      }
      if(localStorage.getItem("selectedStyleId") != null)
      {
        this.selectedStyle = {id:localStorage.getItem("selectedStyleId"),name:localStorage.getItem("selectedStyleName"),image:localStorage.getItem("selectedStyleImage")};
      }
      this.styles=[];
      this.getRandomStyles();
      var resizingTextareas = [].slice.call(document.querySelectorAll('textarea[autoresize]'));
    
    resizingTextareas.forEach(function(textarea) {
      textarea.addEventListener('input', autoresize, false);
      
    });
    function autoresize() {
        //findType(this)
      if(this.scrollHeight < 300 && this.scrollHeight > 57)
      {
      this.style.height = 'auto';
      this.style.height = this.scrollHeight+'px';
      }
    }
    }
}
</script>
<style lang="scss" scoped>
 @media (max-height: 600px) {
  .scrolling {
    height: 100%;
  }
}
@media (max-height: 600px) {
  .scrollfix
   {
    margin-left:-5px;
  }
}
.custom
{
  filter:blur(5px);
}
.circle-div {
    background-color: #6153cc;
    height: 60px;
    width: 90vw;
    border-radius: 10px;
    position: fixed;
    bottom: 80px;
    right: 20px;
}
::placeholder {
  color: rgb(185, 185, 185);
  opacity: 1; /* Firefox */
}

::-ms-input-placeholder { /* Edge 12 -18 */
  color: rgb(185, 185, 185);
}
.login-box {
  top: 50%;
        left: 50%;
        position: fixed;
  width: 90vw;
  padding: 5px;
  transform: translate(-50%, -50%);
z-index: 10000;
  background-color:rgb(24, 24, 24);
  box-sizing: border-box;
  box-shadow: 0 15px 25px rgba(0,0,0,.6);
  border-radius: 10px;

}
@font-face {
        font-family: IRANSansWeb;
        src: url('../assets/IRANSansWeb.woff2') format("woff2");
        font-weight: normal;
        font-style: normal;
    }
    @font-face {
        font-family: IRANSansWeb;
        src: url('../assets/IRANSansWebBold.woff2') format("woff2");
        font-weight: bold;
        font-style: normal;
    }
    span {
  font-family: IRANSansWeb;
  font-weight: bold;
}
@function gray($color){
  @return rgb($color, $color, $color);
}

$red: rgb(239, 83, 80);
$orange: rgb(255, 160, 0);
$yellow: rgb(253, 216, 53);
$green: rgb(42, 252, 152);
$indigo: rgb(57, 73, 171);
$violet: rgb(103, 58, 183);

/* -- */

$blue: rgb(66, 165, 245);

@keyframes blink {
  from, 25%, to {
    opacity: 1;
  }
  
  50% {
    opacity: 0;
  }
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }

  50% {
    transform: rotate(720deg);
  }

  to {
    transform: rotate(1440deg);
  }
}

@keyframes bounce {
  from, 6.66%, 17.66%, 33.33% {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    transform: translate3d(0, 0, 0);
  }

  13.33%, 14.33% {
    animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
    transform: translate3d(0, -30px, 0) scaleY(1.1);
  }

  23.33% {
    animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
    transform: translate3d(0, -15px, 0) scaleY(1.05);
  }

  26.66% {
    transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    transform: translate3d(0, 0, 0) scaleY(0.95);
  }

  30% {
    transform: translate3d(0, -4px, 0) scaleY(1.02);
  }
}

body{
  margin: 0px;
  overflow-x: hidden;
  padding: 0px;
  
  &::-webkit-scrollbar-track {
    background-color: gray(30);
  }
  
  &::-webkit-scrollbar-thumb {
    background-color: rgba(white, 0.2);
    border-radius: 100px;
  }

  &::-webkit-scrollbar {
    height: 4px;
    width: 4px;
  }

  input, h1, h3, a, span {
    color: gray(90);
    font-family:IRANSansWeb;
    font-weight: bold;
    font-weight: 400;
    margin: 0px;
    padding: 0px;
  }
}

$backgroundImage: "https://images.unsplash.com/photo-1483728642387-6c3bdd6c93e5?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2076&q=80";

.background-image {
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

.clear-button {
  backdrop-filter: blur(3px);
  background-color: rgba(white, 0.1);
  border: 1px solid rgba(white, 0.1);
  border-radius: 100px;
  box-shadow: 2px 2px 2px rgba(black, 0.1);
  cursor: pointer;
  
  &:hover {
    background-color: rgba(white, 0.2);
    border: 1px solid rgba(white, 0.3);
  }
}
.text-button {
  backdrop-filter: blur(3px);
  background-color: rgba(white, 0.1);
  border-radius: 15px;
  box-shadow: 2px 2px 2px rgba(black, 0.1);
  cursor: pointer;
  
  &:hover {
    background-color: rgba(white, 0.2);
    border: 1px solid rgba(white, 0.3);
  }
}
.text-button2 {
  background-color: rgba(white, 0.1);
  
}
#app {
  background-color: gray(30);
  
  &.logged-out {
    #app-info {
      margin-left: 40px;
      opacity: 1;
      transform: translateX(0%);
    }
    
    #app-background {
      cursor: pointer;
    }
    
    #sign-in-button-wrapper {
      opacity: 1;
      pointer-events: all;
      transform: translate(-50%, -40px); 
    }
  }
  
  &.logging-in,
  &.verifying-log-in,
  &.log-in-error {
    #app-background {
      #app-background-image {
        filter: blur(8px);
        transform: scale(1.2);
      }
    }
  }
  
  &.logging-in,
  &.log-in-error {
    #app-pin-wrapper {
      opacity: 1;
      pointer-events: all;
      transform: translate(-50%, -50%) scale(1);
    }
  }
  
  &.verifying-log-in {
    #app-loading-icon {
      opacity: 1;
      transform: translate(-50%, -50%);
    }
  }
  
  &.log-in-error {
    #app-pin-wrapper {
      #app-pin {
        .app-pin-digit {
          background-color: rgba($red, 0.05);
          border-color: rgba($red, 0.5); 
        }      
      }
    }
  }
  
  &.logged-in {
    #app-menu {
      opacity: 1;
      pointer-events: all;
    }
  }
  
  .scrollable-component {
    cursor: grab;
    overflow: auto;
    user-select: none;
    width: 100%;
    
    &:active {
      cursor: grabbing;
    }
    
    &::-webkit-scrollbar {
      height: 0px;
      width: 0px;
    }
  }
  
  #app-loading-icon {
    left: 50%;
    opacity: 0;
    pointer-events: none;
    position: absolute;
    top: 50%;
    transform: translate(-50%, 0%);
    transition: opacity 250ms, transform 250ms;
    z-index: 2;
    
    i {
      animation: 2s spin ease-in-out infinite;
      color: white;
      font-size: 2em;
    }
  }
  
  #app-background {
    height: 100%;
    left: 0px;
    overflow: hidden;
    position: fixed;
    top: 0px;
    width: 100%;
    z-index: 1;
    
    #app-background-image {
      height: 100%;
      transition: filter 250ms, transform 250ms;
      width: 100%;
    }
  }
  
  #app-info {
    bottom: 0px;
    left: 0px;
    margin: 40px;
    margin-left: 0px;
    opacity: 0;
    position: absolute;
    transform: translateX(-100%);
    transition: margin 250ms, opacity 250ms, transform 250ms;
    z-index: 2;
  }
  
  .user-status-button {
    cursor: pointer;
    margin-top: 10px;
    outline: none;
    padding: 10px;
    width: 100px;
    
    i {
      color: gray(245);
      font-size: 1.25em;
    }
  }
  
  #sign-in-button-wrapper {
    bottom: 0px;
    left: 50%;
    opacity: 0;
    pointer-events: none;
    position: absolute;
    transform: translate(-50%, 40px);
    transition: opacity 250ms, transform 250ms;
    z-index: 2;
    
    #sign-in-button {
      &:not(:hover) {
        animation: bounce 3s infinite;
        animation-delay: 3s;
      }
    }
  }
  
  .info {
    align-items: flex-end;
    display: flex;
    
    .time {
      color: gray(245);
      font-size: 6em;
      height: 80px;
      line-height: 80px;
      text-shadow: 2px 2px 2px rgba(black, 0.1);
    }
    
    .weather {
      display: inline-flex;
      height: 20px;
      margin-bottom: 6px;
      margin-left: 20px;
      
      i, span {
        align-items: center;
        display: inline-flex;
      }
      
      i {
        color: $yellow;
        font-size: 0.9em;
      }
      
      span {
        color: white;
      }
      
      .weather-type {
        height: 20px;
      }
      
      .weather-temperature-value {        
        font-size: 1.5em;
        height: 20px;
        margin-left: 5px;
      }
      
      .weather-temperature-unit {
        align-items: flex-start;
        font-size: 0.8em;
        margin-left: 3px;
      }
    }
  }
  
  .reminder {
    display: flex;    
    gap: 6px;
    margin-top: 10px;
    
    i, div {
      display: inline-flex;     
    }
    
    i {
      color: gray(245);
      font-size: 0.8em;
      height: 12px;
      line-height: 12px;
    }
    
    span {
      color: rgba(white, 0.8);
      font-size: 1.1em;
    }
    
    .reminder-icon {
      align-items: center;
      height: 20px;
    }
    
    .reminder-time {
      align-items: flex-end;
      color: gray(30);
      font-size: 0.8em;
      height: 20px;
    }
  }
  
  #quick-nav {
    display: flex;
    gap: 10px;
    margin-top: 20px;
    overflow: auto;
    padding-bottom: 5px;
    width: 100%;
    z-index: 3;
    
    .quick-nav-item {
      padding: 10px 20px;
      
      &:last-of-type {
        margin-right: 10px;
      }
      
      .quick-nav-item-label {
        color: gray(245);
        text-shadow: 0px 0px 2px rgba(black, 0.1);
      }
    }
  }
  
  #youtube-link {
    align-items: center;
    display: inline-flex;
    gap: 5px;
    margin-top: 10px;
    padding: 10px 20px;
    text-decoration: none;
    
    i, span {
      height: 20px;
      line-height: 20px;
    }
    
    i {
      color: $red;
    }
    
    span {
      color: white;
    }
  }
  
  .menu-section {
    margin-top: 40px;
    
    .menu-section-title {
      align-items: center;
      display: flex;
      gap: 6px;
      
      i, span {
        color: gray(245);
      }
      
      i {
        font-size: 1em;
      }
      
      .menu-section-title-text {
        color: rgba(white, 0.9);
        font-size: 1.4em;
        font-weight:bold;
      } 
    }
    
    .menu-section-content {
      margin-top: 15px;      
      padding-top: 5px;
    }
  }
  
  #restaurants-section { 
    .menu-section-content {
      display: flex;
      gap: 1em;
      
      .restaurant-card {
        border-radius: 10px;
        box-shadow: 2px 2px 4px rgba(black, 0.25);
        cursor: pointer;
        height: 14vw;
        max-height: 240px;
        position: relative;
        transition: transform 250ms;
        width: 25%;
        
        &:hover {
          transform: translateY(-5px);
          
          .restaurant-card-content {            
            .restaurant-card-content-items {
              margin-bottom: 30px;   
            }
          }
        }
        
        .restaurant-card-content {
          background: linear-gradient(to top, rgba(black, 0.8), transparent);
          border-radius: 10px;
          height: 100%;
          width: 100%;
          
          .restaurant-card-content-items {
            bottom: 0px;
            display: flex;
            flex-direction: column;
            margin: 20px;
            position: absolute;
            right: 0px;
            text-align: right;
            transition: margin 250ms;
            
            .restaurant-card-title {
              color: gray(245);
              font-size: 1.5em;
            }

            .restaurant-card-desc {
              color: $blue;
              font-size: 0.9em;
            }
          }
        }
      }
    }
  }
  
  #weather-section {
    .menu-section-content {
      display: flex;
      gap: 1em;
      padding: 5px 0px;
      width: 100%;      

      .day-card {
        backdrop-filter: blur(3px);
        background-color: rgba(white, 0.1);
        border: 1px solid rgba(white, 0.2);
        border-radius: 10px;
        box-shadow: 2px 2px 4px rgba(black, 0.25);
        height: 8vw;
        max-height: 160px;
        min-height: 140px;
        min-width: 180px;
        position: relative;
        transition: transform 250ms;
        width: calc(100% / 7);
        
        &:last-of-type {
          margin-right: 5px;
        }

        .day-card-content {
          display: flex;
          flex-direction: column;
          height: calc(100% - 20px);
          justify-content: space-evenly;
          padding: 10px;

          i, span {
            color: gray(245);
            text-align: center;
          }

          .day-weather-temperature {
            align-items: flex-start;
            display: flex;
            font-size: 0.9em;
            justify-content: center;

            .day-weather-temperature-unit {
              font-size: 0.8em;
              margin-left: 3px;
            }
          }

          .day-weather-icon {
            font-size: 3.5em;
            text-shadow: 2px 2px 2px rgba(black, 0.1);

            &.sunny {
              color: $yellow;
            }

            &.rainy,
            &.stormy {
              color: $blue;
            }
          }

          .day-name {
            font-size: 0.9em;
            text-transform: uppercase;
          }
        }
      }
    }
  }
  
  #tools-section {
    .menu-section-content {
      display: flex;
      gap: 1em;
      width: 100%;      
        height:60vh;
      .tool-card {
        background-color: gray(30);
        border-radius: 10px;
        box-shadow: 2px 2px 4px rgba(black, 0.25);
        cursor: pointer;
        height: vw;
        max-height: 220px;
        min-height: 180px;
        min-width: 220px;

        position: relative;
        transition: transform 250ms;
        width: calc(100% / 6);
        
        &:hover {
          transform: translateY(-5px);
          
          .tool-card-background {
            filter: grayscale(0);
          }
        }
        
        .tool-card-background {
          border-radius: 10px;
          height: 100%;
          left: 0px;
          position: absolute;
          top: 0px;
          transition: filter 250ms;
          width: 100%;
        }
        
        .tool-card-content {
          display: flex;

          i, span {
            color: gray(245);
          position: absolute;
       width:100%;
       height:60%;

            }
          
          .tool-card-content-header {
            display: flex;
            flex-direction: column;
            gap: 2px;


            
          }

          .tool-card-icon {
            color: gray(245);
            font-size: 2em;
          }
        }
      }
    }
  }
  
  #movies-section {
    .menu-section-content {
      display: flex;
      gap: 1em;
      
      #movie-card-1 {
        .movie-card-content {
          background: linear-gradient(to top, rgba($indigo, 0.4), transparent, rgba(black, 0.4));
        }
      }
        
      #movie-card-2 {
        .movie-card-content {
          background: linear-gradient(to top, rgba($violet, 0.4), transparent, rgba(black, 0.4));
        }
      }
        
      #movie-card-3 {
        .movie-card-content {
          background: linear-gradient(to top, rgba($red, 0.4), transparent, rgba(black, 0.4));
        }
      }
        
      #movie-card-4 {
        .movie-card-content {
          background: linear-gradient(to top, rgba($green, 0.4), rgba(black, 0.1), rgba(black, 0.4));
        }
      }
        
      .movie-card {
        background-color: gray(30);
        border-radius: 10px;
        box-shadow: 2px 2px 4px rgba(black, 0.25);
        cursor: pointer;
        height: 40vw;
        max-height: 600px;
        min-height: 460px;
        min-width: 260px;
        overflow: hidden;
        position: relative;
        transition: transform 250ms;
        width: calc(100% / 4);
        
        &:hover {
          transform: translateY(-5px);
          
          .movie-card-background {
            transform: scale(1.05);
          }
          
          .movie-card-content {
            i {
              transform: translate(-20%, -20%) scale(1.2);
            } 
          }
        }
        
        .movie-card-background {
          border-radius: 10px;
          height: 100%;
          left: 0px;
          position: absolute;
          top: 0px;
          transition: transform 250ms;
          width: 100%;
          z-index: 1;
        }
        
        .movie-card-content {
          background: linear-gradient(to top, rgba(black, 0.5), rgba(black, 0.1), rgba(black, 0.4));
          border-radius: 10px;
          height: 100%;
          position: relative;
          z-index: 2;
          
          .movie-card-info {
            display: flex;
            flex-direction: column;
            gap: 5px;
            padding: 30px;
            
            span {              
              text-shadow: 2px 2px 2px rgba(black, 0.1);
            }
            
            .movie-card-title {
              color: gray(245);
              font-size: 1.5em;
              font-weight:bold;
            }
            
            .movie-card-desc {
              color: gray(200);
              font-size: 0.9em;
            }            
          }
          
          i {
            bottom: 0px;
            color: gray(245);
            font-size: 5em;
            padding: 30px;
            position: absolute;
            right: 0px;
            text-shadow: 2px 2px 2px rgba(black, 0.1);
            transition: transform 250ms;
          }
        }
      }
    }
  }
  
  #app-pin-wrapper {
    left: 50%;
    opacity: 0;        
    pointer-events: none;
    position: absolute;
    top: 50%;    
    transform: translate(-50%, -30%) scale(0.8);
    transition: opacity 250ms, transform 250ms;
    z-index: 2;
    
    #app-pin-label {
      color: gray(245);
      font-size: 0.9em;
      margin: 10px;
      text-shadow: 2px 2px 2px rgba(black, 0.1);
      
      #app-pin-cancel-text {
        cursor: pointer;
        margin-left: 2px;
        
        &:hover {
          text-decoration: underline;
        }
      }
      
      #app-pin-error-text {
        color: $red;
      }
    }
    
    #app-pin-hidden-input {
      background-color: transparent;
      border: none;
      height: 0px;
      outline: none;
      pointer-events: none;
      position: absolute;
      width: 0px;
    }
    
    #app-pin {
      display: flex;
      gap: 10px;
      
      .app-pin-digit {
        align-items: center;
        background-color: rgba(white, 0.05);
        border: 1px solid rgba(white, 0.2);
        border-radius: 10px;
        box-shadow: 2px 2px 2px rgba(black, 0.06);
        display: inline-flex;
        font-size: 3em;
        height: 80px;
        justify-content: center;
        position: relative;
        transition: background-color 250ms, border-color 250ms;
        width: 60px;
        
        &:after,
        &:before {
          box-shadow: 2px 2px 2px rgba(black, 0.06);
          content: "";
          position: absolute;
          transition: opacity 250ms, transform 250ms;
          z-index: 2;
        }
        
        &:before {
          background-color: gray(245);
          border-radius: 10px;
          bottom: 0px;
          height: 3px;
          left: 15%;
          opacity: 0;
          transform: translateY(0px);
          width: 70%;
        }
        
        &:after {
          background-color: gray(245);
          border-radius: 20px;
          height: 20px;
          opacity: 0;
          transform: scale(0.25);
          width: 20px;
        }
        &.focused {
          &:before {
            animation: blink 2s ease-in-out infinite;
            opacity: 1;
            transform: translateY(-10px);
          }
        }
        
        &.hidden {
          &:after {
            opacity: 1;
            transform: scale(1);
          }
          
          .app-pin-digit-value {
            opacity: 0;
            transform: scale(0.25);
          }
        }
        
        .app-pin-digit-value {
          color: gray(245);
          transition: opacity 250ms, transform 250ms;
        }
      }
    }
  }
  
  #app-menu {
    overflow: hidden;
    opacity: 0;
    pointer-events: none;
    position: relative;
    transition: opacity 250ms, transform 250ms;
    z-index: 2;
    margin-top:30px;

    #app-menu-content-wrapper {
      background: #212529;
      min-height: 80vh;
      padding: 80px;
      padding-top: 0px;
      
      #app-menu-content {
        margin: auto;
        max-width: 1600px;
        position: relative;
        
        #app-menu-content-header {
          display: flex;
          justify-content: space-between;
        }
      }
    }
  }
}

@media(max-width: 1300px) {
  #app {
    &.logged-out {
      #sign-in-button-wrapper {
        transform: translate(-40px, 0px); 
      }
    }
  
    #sign-in-button-wrapper {
      bottom: 40px;
      left: auto;
      right: 0px;
      transform: translate(40px, 0px); 
    }
    
    #app-menu {
      #app-menu-content-wrapper {
        padding: 20px;
        
        #app-menu-content {
          #restaurants-section { 
            .menu-section-content {
              flex-wrap: wrap;

              .restaurant-card {
                height: 22vh;;
                max-height: 300px;
                position: relative;
                width: calc(50% - 0.5em);
              }
            }
          }
          
          #tools-section {
            .menu-section-content {
              
              .tool-card {
                width: 50vw;
              }
            }
          }
        }
      }
    }
  }
}

@media(max-width: 600px) {
  #app {
    .info {
      .time {
        font-size: 4em;
        height: 60px;
        line-height: 60px;
      }
    }
    
    .user-status-button {
      width: 60px;
    }
  
    #app-menu {
      #app-menu-content-wrapper {
        #app-menu-content {  
          #restaurants-section { 
            .menu-section-content {
              flex-direction: column;

              .restaurant-card {
                height: 40vw;
                position: relative;
                width: 100%;
              }
            }
          }
          
          #tools-section {
            .menu-section-content {
              
              .tool-card {
                width: 50vw;
              }
            }
          }
        }
      }
    }
  }
}

@media(max-width: 400px) {
  #app {
    #app-menu {
      #app-menu-content-wrapper {
        #app-menu-content {
          #tools-section {
            .menu-section-content {
              
              .tool-card {
                width: 50vw;
              }
            }
          }
        }
      }
    }
  }
}
.overflow2 {
  margin: 0 0 0 0;
  text-overflow: ellipsis;
  width:82vw;
  /**
   * Required properties to achieve text-overflow
   */
    white-space: nowrap;
    overflow: hidden;
}
.overflow {
  margin: 0 0 2em 0;
  text-overflow: ellipsis;
  /**
   * Required properties to achieve text-overflow
   */
    white-space: nowrap;
    overflow: hidden;
}
</style>